import * as THREE from 'three';
import type { NodeImplementation } from '@spotar/runtime';
import { Character, type CharacterData, type Vector3Deg } from '../character';
import { sceneHelper } from '../helper/scene-helper';

interface MoveToData {
  position: THREE.Vector3;
  rotation: Vector3Deg;
}

type CharacterMoveToData = CharacterData &
  MoveToData & {
    speedFactor?: number;
  };

export const runCharacterMoveToImplementation: NodeImplementation = async (
  data,
  nodeId
) => {
  const { position, rotation, ...characterData } = data as CharacterMoveToData;
  const object = sceneHelper?.getObjectByUUID(characterData.target.id);
  if (!object) {
    console.error(`Object ${characterData.target.id} not found`);
    return;
  }

  const character = new Character(characterData, object, nodeId);
  await character.moveTo(position, rotation);
};
